import type {RouteLocationRaw} from 'vue-router'
import {useRouter} from 'vue-router'
import {useI18n} from 'vue-i18n'
import {useMessages} from '@toolify/client/src/modules/notifications/composables/useMessages'
import {isAiResourceAlreadyOpen} from '@toolify/client/src/modules/chat/functions/isAiResourceAlreadyOpen'

export function useOpenAiResource() {
  const router = useRouter()
  const messages = useMessages()
  const {t} = useI18n()

  function isAlreadyOpen(location: RouteLocationRaw): boolean {
    return isAiResourceAlreadyOpen(router.resolve(location), router.currentRoute.value)
  }

  function notifyAlreadyOpen(): void {
    messages.info(t('chat.aiResourceAlreadyOpen'), {
      collapseKey: 'chat.aiResourceAlreadyOpen',
    })
  }

  async function openAiResource(location: RouteLocationRaw): Promise<void> {
    if(isAlreadyOpen(location)) {
      notifyAlreadyOpen()
      return
    }
    await router.push(location)
  }

  return {
    isAlreadyOpen,
    notifyAlreadyOpen,
    openAiResource,
  }
}
